import { apiDelete, apiGet, apiPost, apiPut } from './http'
import { downloadBlobResponse } from './helpers'

export const findAll = async (params = {}) => apiGet('/fines', { auth: true, config: { params } })

export const findById = async id => apiGet(`/fines/${id}`, { auth: true })

export const create = async payload => apiPost('/fines', payload, { auth: true })

export const update = async ({ id, ...payload }) => apiPut(`/fines/${id}`, payload, { auth: true })

export const remove = async id => apiDelete(`/fines/${id}`, { auth: true })

export const downloadExcel = async payload => {
  const response = await apiPost('/docs/commonexpenses/xls', payload, {
    auth: true,
    rawResponse: true,
    config: { responseType: 'blob' },
  })

  if (!response || !response.data) return response

  downloadBlobResponse(response, payload.fileName, 'xlsx')
  return { ok: true }
}
